<template>
  <!-- User Profile Address Edit Info Tab Content View From Account Profile -->
  <div>
    <div class="tabs-content-secondblock mb-7">
      <div class="row" v-if="ajaxCallinprogress">
        <div class="col-lg-12 py-5 px-3 mt-10">
          <div class="flex-container">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
          </div>
        </div>
      </div>
      <div class="row" v-if="!ajaxCallinprogress">
        <div class="col-lg-12">
          <div
            class="ml-2 mr-1 mb-2"
            v-for="(address_field, index) in address"
            :key="index"
          >
            <div class="infoHeader pb-4">
              <div class="d-flex justify-content-between align-items-center" style="background-color: #005dae; ">
                <h6 class="subHeaderTitle ml-4 text-white">
                  {{address_field.address_type || "Current Address (Shipping Address)"}}
                  <sup v-if="index > 0" class="fs-14 ml-1 mandatory">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="The options for this field are configurable in the Settings page"
                      placement="right"
                    >
                      <i class="icon-information text-secondary" style="font-size: 14px"></i>
                    </el-tooltip>
                  </sup>
                </h6>
                <div class="d-flex align-items-center">
                    <div v-if="edit_full_address == true && edit_full_address_index == index" class="d-flex justify-content-end align-items-center mr-4">
                        <div class="pointer" @click="resetUser('full_address_add_update',index)">
                            <img src="/static/images/check.svg">
                        </div>
                        <div class="ml-2 pointer" @click="addAddressMethod('full_address_add_update', index)">
                            <img src="/static/images/close.svg">
                        </div>
                    </div>
                    <div v-else>
                        <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                            <button class="btn-icon pointer mr-4" @click="editFullAddress(index)" style="padding:0px!important;">
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/edit-white.svg" height="15px;">
                            </button>
                        </el-tooltip>
                    </div>
                  <el-dropdown v-if="index > 0 && $route.params.id == loggedInUser.user_id" trigger="click" :hide-on-click="true" style="width: auto">
                    <span class="el-dropdown-link mr-4">
                      <i class="el-icon-arrow-down el-icon--right text-white" style="font-weight: 500; font-size: 20px;"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in addressTypes" :key="item" @click.native="address_field.address_type = item">{{item}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="a-q-Jc-j-editcontactView" v-if="index != 0 && $route.params.id == loggedInUser.user_id">
                <div class="mt-3 mb-3 ml-4">
                  <label class="custom-control custom-checkbox digi-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      @input="duplicatePermanentAddress($event, index)"
                      :checked="boolDuplicateAddress.includes(index)"
                    />
                    <span class="custom-control-indicator"></span>
                    <span class="form-check-description fw-600">Same as Permanent Address</span>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div v-if="$route.params.id == loggedInUser.user_id" class="d-flex justify-content-between align-items-center mt-1 px-3">
                    <div class="form-group gMap" style="position:relative;width:100%;">
                      <gmap-autocomplete
                        class="inputFieldNoBorder mt-0"
                        id="autocompleteInput"
                        name="get_location"
                        v-validate="'required'"
                        placeholder="Search Location"
                        :disabled="address_field.same_as_permanent_address == true || !(edit_full_address == true && edit_full_address_index == index)"
                        @place_changed="setPlace($event,index)"
                        :value="address_field.location_vmodel"
                        v-model="address_field.location_vmodel"
                        style="padding: 8px 32px 8px 18px !important; height: 40px;"
                      ></gmap-autocomplete>
                      <img
                        src="/static/images/images-new-theme/icons/marker_pin.svg"
                        style="position: absolute;right: 12px;bottom: 10px;"
                      />
                    </div>
                    <div class="form-group gMap ml-4" :class="{'pointerEventsNone':address_field.same_as_permanent_address == true || !(edit_full_address == true && edit_full_address_index == index)}" style="cursor: pointer;" @click="getLocation(index)">
                      <img src="/static/images/images-new-theme/icons/GPS 2.svg" style="height: 40px;" />
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3 font-weight-bold">Country <span class="pl-1 text-danger">*</span></div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                            <div class="d-flex align-content-center w-100" style="position: relative;">
                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                    <multiselect
                                        @open="resetValue('country', index)"
                                        :max-height="200"
                                        :name="'country'+index"
                                        class="digi-multiselect loaderbg mt-1"
                                        v-model="address_field.country"
                                        @input="address_field.state = '', address_field.city = '',address_field.street = '',address_field.township = '',address_field.zip_code = '',address_field.location_vmodel = ''"
                                        :options="countries"
                                        @close="countryClose(address_field.country, index)"
                                        :disabled="$route.params.id != loggedInUser.user_id"
                                        :searchable="true"
                                        :close-on-select="true"
                                        v-validate="'required'"
                                        :show-labels="false"
                                        data-vv-scope="Country"
                                        placeholder="Select Country"
                                    >
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">List is Empty</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </el-tooltip>
                                <div v-if="edit_country == true && edit_country_index == index" class="d-flex justify-content-end align-items-center">
                                    <div class="pointer" @click="resetUser('country',index)">
                                        <img src="/static/images/check.svg">
                                    </div>
                                    <div class="ml-2 pointer" @click="addAddressMethod('country', index)">
                                        <img src="/static/images/close.svg">
                                    </div>
                                </div>
                                <div style="position: absolute; bottom: -18px;">
                                    <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-if="country_check_index == index && select_country == true">Country is Required.</span>
                                </div>
                            </div>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3 font-weight-bold">State</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                            <div class="d-flex align-content-center w-100">
                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                    <multiselect
                                        :max-height="200"
                                        name="country"
                                        class="digi-multiselect loaderbg mt-1"
                                        v-model="address_field.state"
                                        @open="updateState(address_field.country, index)"
                                        :options="states"
                                        :disabled="$route.params.id != loggedInUser.user_id"
                                        @close="stateClose(address_field.state, index)"
                                        :searchable="true"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        :loading="isState"
                                        data-vv-scope="userData"
                                        :placeholder="address_field.country ? 'Select State' : 'Select Country to view States'"
                                    >
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">List is Empty</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                </el-tooltip>
                                <div v-if="edit_state == true && edit_state_index == index" class="d-flex justify-content-end align-items-center">
                                    <div class="pointer" @click="resetUser('state',index)">
                                        <img src="/static/images/check.svg">
                                    </div>
                                    <div class="ml-2 pointer" @click="addAddressMethod('state', index)">
                                        <img src="/static/images/close.svg">
                                    </div>
                                </div>
                            </div>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3 font-weight-bold">City</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView">
                            <div class="d-flex align-items-center w-100">
                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                    <input
                                        class="inputField"
                                        type="text"
                                        name="city"
                                        style="padding-left: 10px !important;"
                                        @focus="resetValue('city', index)"
                                        data-vv-scope="userData"
                                        :maxlength="maxlengthaccounttownship"
                                        data-vv-as="City"
                                        :readonly="!edit_city"
                                        v-model="address_field.city"
                                        placeholder="Enter City"
                                        oninput="this = this.toUpperCase()"
                                    />
                                </el-tooltip>
                                <div v-if="edit_city == true && edit_city_index == index" class="d-flex justify-content-end align-items-center">
                                    <div class="pointer" @click="resetUser('city',index)">
                                        <img src="/static/images/check.svg">
                                    </div>
                                    <div class="ml-2 pointer" @click="addAddressMethod('city', index)">
                                        <img src="/static/images/close.svg">
                                    </div>
                                </div>
                            </div>
                          <div
                            class="text-right text-grey"
                          ><span>{{(address_field.city).length}}/30</span></div>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView mt-1">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3 font-weight-bold">Township</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView font-color">
                            <div class="d-flex justify-content-end align-items-center">
                                <div class="d-flex align-items-center w-100">
                                    <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                        <input
                                            class="inputField"
                                            type="text"
                                            name="township"
                                            @focus="resetValue('township', index)"
                                            :readonly="!edit_township"
                                            data-vv-scope="userData"
                                            style="padding-left: 10px !important;"
                                            :maxlength="maxlengthaccounttownship"
                                            data-vv-as="Township"
                                            v-model="address_field.township"
                                            placeholder="Enter Township"
                                            oninput="this = this.toUpperCase()"
                                        />
                                    </el-tooltip>
                                    <div v-if="edit_township == true && edit_township_index == index" class="d-flex justify-content-end align-items-center">
                                        <div class="pointer" @click="resetUser('township',index)">
                                            <img src="/static/images/check.svg">
                                        </div>
                                        <div class="ml-2 pointer" @click="addAddressMethod('township', index)">
                                            <img src="/static/images/close.svg">
                                        </div>
                                    </div>
                                </div>
                            </div>
                          <div
                            class="text-right text-grey"
                          ><span>{{(address_field.township).length}}/30</span></div>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView mt-1">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3 font-weight-bold">Street</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView font-color">
                            <div class="d-flex align-items-center w-100">
                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                    <input
                                        class="inputField"
                                        type="text"
                                        data-vv-scope="userData"
                                        name="street"
                                        @focus="resetValue('street', index)"
                                        :readonly="!edit_street"
                                        :maxlength="maxlengthaccountstreet"
                                        v-model="address_field.street"
                                        style="padding-left: 10px !important;"
                                        data-vv-as="Street"
                                        placeholder="Enter Street"
                                        oninput="this = this.toUpperCase()"
                                    />
                                </el-tooltip>
                                <div v-if="edit_street == true && edit_street_index == index" class="d-flex justify-content-end align-items-center">
                                    <div class="pointer" @click="resetUser('street',index)">
                                        <img src="/static/images/check.svg">
                                    </div>
                                    <div class="ml-2 pointer" @click="addAddressMethod('street', index)">
                                        <img src="/static/images/close.svg">
                                    </div>
                                </div>
                            </div>
                          <div
                            class="text-right text-grey"
                          ><span>{{(address_field.street).length}}/30</span></div>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="a-q-Jc-j-editcontactView">
                    <div class="a-q-Jc-Pj-Ya-editcontactView">
                      <div class="a-q-Jc-bj-editcontactView defaultDarkBlue mt-3 font-weight-bold">Zip Code</div>
                      <div class="a-q-Jc-Lb-editcontactView">
                        <span class="a-q-Jc-wg-editcontactView text-runcate">
                            <div class="d-flex align-items-center w-100">
                                <el-tooltip class="item" effect="dark" content="Click to edit" placement="top">
                                    <input
                                        class="inputField"
                                        type="text"
                                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                        name="pin_code"
                                        @focus="resetValue('zip_code', index)"
                                        :readonly="!edit_zip_code"
                                        :maxlength="maxlengthaccountzipcode"
                                        style="padding-left: 10px !important;"
                                        data-vv-scope="userData"
                                        v-model="address_field.zip_code"
                                        data-vv-as="Zip Code"
                                        placeholder="Enter Zip Code"
                                    />
                                </el-tooltip>
                                <div v-if="edit_zip_code == true && edit_zip_code_index == index" class="d-flex justify-content-end align-items-center">
                                    <div class="pointer" @click="resetUser('zip_code',index)">
                                        <img src="/static/images/check.svg">
                                    </div>
                                    <div class="ml-2 pointer" @click="addAddressMethod('zip_code', index)">
                                        <img src="/static/images/close.svg">
                                    </div>
                                </div>
                            </div>
                          <div
                            class="text-right text-grey"
                          ><span>{{(address_field.zip_code).length}}/30</span></div>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div v-if="$route.params.id == loggedInUser.user_id" class="d-flex justify-content-end mt-8 mr-2">
                    <button
                      type="button"
                      class="btn btn-new-primary btn-smm d-flex align-items-center mr-2"
                      style="box-shadow: none;"
                      @click="resetAddress(index)"
                    ><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset-icon.svg" style="width: 10px; height: 10px; margin-right: 6px;" /> Reset</button>
                    <button
                      type="button"
                      class="btn btn-new-danger btn-smm mr-2"
                      style="box-shadow: none;"
                      v-if="index!=0"
                      @click="deleteAddress"
                    >- Delete Address</button>
                    <button
                      type="button"
                      class="btn btn-new-primary btn-smm"
                      style="box-shadow: none;"
                      v-if="index+1 == address.length"
                      @click="addAddress"
                    >+ Add Address</button>
                  </div>
                </div>
              </div>
            </div>
            <delete-address modal_name="deleteAddress" :address_type="address_field.address_type" :address_id="address_field.id ? address_field.id : ''" :index="index" @addressDelete="addressDelete" @cancelDelete="cancelDelete"></delete-address>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { User } from "./mixins/user";
import countries from "./json/countries.json";
import { HalfCircleSpinner } from "epic-spinners";
import { EventBus } from "./eventBus/nav-bar-event.js";
import DeleteAddress from "./alertModals/DeleteAddress";
import axios from "axios";
import profile from './mixins/profile';
export default {
  data() {
    return {
        maxlengthaccountzipcode: 30,
        maxlengthaccounttownship: 30,
        maxlengthaccountstreet: 30,
        permanentAddress: false,
        activatePermanentAddress: false,
        countries: countries,
        states: [],
        ajaxCallinprogress: false,
        requestResponse: false,
        same_as_permanent_address: false,
        same_as_permanent_address_index: 0,
        userBasicInfo: {},
        address: {
            value: {
            street: "",
            city: "",
            township: "",
            state: "",
            country: "",
            zip_code: "",
            address_type: "Current Address",
            location_vmodel: ""
            },
            privacy: "contacts",
        },
        boolDuplicateAddress: [],
        addressTypes: [
            "Work Address",
            "Current Address",
            "Billing Address",
        ],
        addressIndex: 0,
        isState:false,
        isCountry:false,
        edit_country: false,
        edit_state: false,
        edit_city: false,
        edit_township: false,
        edit_street: false,
        edit_zip_code: false,
        edit_country_index: 0,
        edit_state_index: 0,
        edit_city_index: 0,
        edit_township_index: 0,
        edit_street_index: 0,
        edit_zip_code_index: 0,
        edit_full_address: false,
        edit_full_address_index: 0,
        select_country: false,
        country_check_index: 0
    };
  },
  mixins: [User, profile],
  methods: {
    countryClose(data, index) {
      this.address[index].country = data;
      this.$forceUpdate();
    },
    stateClose(data, index) {
      this.address[index].state = data;
      this.$forceUpdate();
    },
    addAddress() {
      this.address.push({
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          address_type: "Current Address",
          zip_code: "",
          location_vmodel: "",
          same_as_permanent_address: false
      });
    },
    deleteAddress() {
      this.$modal.show("deleteAddress");
    },
    editFullAddress(index) {
        this.edit_full_address = true;
        this.edit_country = false;
        this.edit_state = false;
        this.edit_city = false;
        this.edit_township = false;
        this.edit_street = false;
        this.edit_zip_code = false;
        this.edit_full_address_index = index;
    },
    async addressDelete(data) {
        this.boolDuplicateAddress = this.boolDuplicateAddress.filter(x => x != data.index);
        if(data.id.length) {
            try {
                let id = data.id;
                let response = await this.deleteAddressById(id);
                if(response.status_id == 1) {
                    this.GetUserDetails(this.$route.params.id);
                }
            }
            catch(err) {
                // console.log(err);
            }
        }
        else {
            this.address.splice(data.index,1);
        }
        this.$modal.hide("deleteAddress");
    },
    cancelDelete() {
      this.$modal.hide("deleteAddress");
    },
    resetAddress(index) {
      if (index === 0) {
        this.address[index] = {
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          zip_code: "",
          address_type: "Permanent Address (Billing Address)",
          location_vmodel: "",
          same_as_permanent_address: false
        };
      } else {
        this.address[index] = {
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          zip_code: "",
          address_type: "Current Address",
          location_vmodel: "",
          same_as_permanent_address: false
        };
      }
      if (this.boolDuplicateAddress.includes(index) && index != 0) {
        this.boolDuplicateAddress = this.boolDuplicateAddress.filter(x => x !== index);
      }
      this.$forceUpdate();
    },
    setPlace(place,index) {
      let currentPlace = place;
      let address = place.formatted_address.split(", ");
      this.address[index].street =
        address[address.length - 3] || "";
      this.address[index].township =
        address[address.length - 4] || "";
      this.address[index].city = currentPlace.vicinity;
      let statezip = address[address.length - 2]
        ? address[address.length - 2].split(" ")
        : ["", ""];
      if (statezip.length == 1) {
        if (statezip[0].match(/^[0-9]+$/)) {
          this.address[index].zip_code = statezip[0];
        } else {
          this.address[index].state = statezip[0];
        }
      } else {
        this.address[index].zip_code = statezip[0].match(/^[0-9]+$/)
          ? statezip[0]
          : statezip[1].match(/^[0-9]+$/)
          ? statezip[1]
          : "";
        this.address[index].state = statezip[0].match(/^[a-zA-Z]+$/)
          ? statezip[0]
          : statezip[1].match(/^[a-zA-Z]+$/)
          ? statezip[1]
          : "";
      }
      if (address[address.length - 1].includes("-")) {
        let countrySelected = address[address.length - 1].split(" - ");
        countrySelected.forEach(x => {
          if (this.countries.includes(x)) {
            this.address[index].country = x;
          } else {
            this.address[index].country = "";
          }
        });
      } else {
        this.address[index].country = address[address.length - 1];
      }
      // this.address[index].address.latitude = currentPlace.geometry.location.lat() || "";
      // this.address[index].address.longitude = currentPlace.geometry.location.lng() || "";
      this.address[index].location_vmodel = place.formatted_address;
      this.$forceUpdate();
    },
    getLocation(index) {
      this.addressIndex = index;
      if (navigator.geolocation) {
        // timeout at 60000 milliseconds (60 seconds)
        var options = {
          enableHighAccuracy: false,
          timeout: 30000, // milliseconds (30 seconds)
          maximumAge: 600000
        }; // milliseconds (10 minutes)
        navigator.geolocation.getCurrentPosition(
          this.showLocation,
          this.errorHandler,
          options
        );
      } else {
        alert("Sorry, browser does not support geolocation!");
      }
    },
    showLocation(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
      let calllatlong = axios.create();
      delete calllatlong.defaults.headers.common['Authorization'];
      calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
      .then(response => {
        let address = response.data.results[0].formatted_address.split(", ");
        this.address[this.addressIndex].street =
          address[address.length - 6] || "";
        this.address[this.addressIndex].township =
          address[address.length - 4] || "";
        this.address[this.addressIndex].city = address[address.length - 3] || "";
        let statezip = address[address.length - 2]
          ? address[address.length - 2].split(" ")
          : ["", ""];
        this.address[this.addressIndex].zip_code = statezip[0].match(/^[0-9]+$/)
          ? statezip[0]
          : statezip[1].match(/^[0-9]+$/)
          ? statezip[1]
          : "";
        this.address[this.addressIndex].state = statezip[0].match(/^[a-zA-Z]+$/)
          ? statezip[0]
          : statezip[1].match(/^[a-zA-Z]+$/)
          ? statezip[1]
          : "";
        if (address[address.length - 1].includes("-")) {
          let countrySelected = address[address.length - 1].split(" - ");
          countrySelected.forEach(x => {
            if (this.countries.includes(x)) {
              this.address[this.addressIndex].country = x;
            } else {
              this.address[this.addressIndex].country = "";
            }
          });
        } else {
          this.address[this.addressIndex].country = address[address.length - 1];
        }
        this.address[this.addressIndex].location_vmodel = response.data.results[0].formatted_address;
        this.$forceUpdate();
      })
      .catch(e => {
        // this.errors.push(e)
      });
    },
    errorHandler(err) {
      if (err.code == 1) {
        // alert("Error: Access is denied!");
      } else if (err.code == 2) {
        // alert("Error: Position is unavailable!");
      }
    },
    duplicatePermanentAddress(event, index) {
      if(event.target.checked) {
        this.address[index].same_as_permanent_address = true;
      } else {
        this.address[index].same_as_permanent_address = false;
      }
      if (this.boolDuplicateAddress.includes(index)) {
        this.boolDuplicateAddress = this.boolDuplicateAddress.filter(x => x !== index);
        this.address[index] = {
          street: "",
          city: "",
          township: "",
          state: "",
          country: "",
          zip_code: "",
          address_type: "Current Address",
          location_vmodel: ""
        };
      } else {
        this.boolDuplicateAddress.push(index);
        this.address[index].city = this.address[0].city;
        this.address[index].country = this.address[0].country;
        this.address[index].location_vmodel = this.address[0].location_vmodel;
        this.address[index].state = this.address[0].state;
        this.address[index].street = this.address[0].street;
        this.address[index].township = this.address[0].township;
        this.address[index].zip_code = this.address[0].zip_code;
      }
    },
    updateContactAddress() {
      this.address.forEach(x => {
        delete x.same_as_permanent_address;
        if (!x.city && !x.country && !x.state && !x.street && !x.township && !x.zip_code) {
          this.address = this.address.filter(i => i != x);
        } else {
          delete x["location_vmodel"];
        }
      });
      this.saveEditUser(this.address);
      this.$emit("updateUserData");
    },
    async GetUserDetails(id) {
      this.ajaxCallinprogress = true;
        let response = await this.getAddressApi(id)
              this.edit_full_address = false;
              this.edit_country = false;
              this.edit_state = false;
              this.edit_city = false;
              this.edit_township = false;
              this.edit_street = false;
              this.edit_zip_code = false;
              this.select_country = false;
            if (response.status_id == 1) {
            localStorage.setItem('address_data', JSON.stringify(response.response));
            this.userBasicInfo = response.response;
            this.address = this.userBasicInfo;
            if (!(this.address.length)) {
              this.address = [
                {
                  value: {
                    street: "",
                    city: "",
                    township: "",
                    state: "",
                    country: "",
                    zip_code: "",
                    address_type: "Current Address",
                    location_vmodel: "",
                  },
                  privacy: "contacts",
                  same_as_permanent_address: false
                }
              ];
            }
            this.address.forEach((x, index) => {
              this.address[index].same_as_permanent_address = false;
              if (!("state" in x)) {
                Object.assign(x, {
                  state: "",
                });
              }
              if (!("city" in x)) {
                Object.assign(x, {
                  city: "",
                });
              }
              if (!("street" in x)) {
                Object.assign(x, {
                  street: "",
                });
              }
              if (!("zip_code" in x)) {
                Object.assign(x, {
                  zip_code: "",
                });
              }
              if (!("township" in x)) {
                Object.assign(x, {
                  township: "",
                });
              }
              if (!("location_vmodel" in x)) {
                Object.assign(x, {
                  location_vmodel: "",
                });
              }
            });
            for (let i = 1; i < this.address.length; i++) {
              let addressSelected = this.address[i];
              if (addressSelected.zip_code == this.address[0].zip_code && addressSelected.township == this.address[0].township && addressSelected.street == this.address[0].street && addressSelected.state == this.address[0].state && addressSelected.country == this.address[0].country && addressSelected.city == this.address[0].city) {
                this.boolDuplicateAddress.push(i);
              }
            };
            if (this.address[0].address_type != "Permanent Address (Billing Address)") {
              this.address[0].address_type = "Permanent Address (Billing Address)";
            }
            this.ajaxCallinprogress = false;
        }
    },
    updateState(country, index) {
        this.resetValue('state', index);
        this.edit_state = true;
        this.isState = true;
        this.states = [];
        if (country) {
            let params = {
            country_required: false,
            state_required: true,
            country_name: country,
            };
            this.$http.post("/location/get_location", params).then(res => {
            if (res.data.status_id == 1 && "all_states" in res.data.response) {
                res.data.response.all_states.forEach(x => {
                this.states.push(x);
                });
                this.isState = false
            }
            });
        }
    },
    resetValue(obj, index) {
        if(this.$route.params.id == this.loggedInUser.user_id) {
            this.edit_full_address = false;
            if (obj == "country") {
                this.edit_country_index = index;
                this.edit_country = true;
                this.edit_state = false;
                this.edit_city = false;
                this.edit_township = false;
                this.edit_street = false;
                this.edit_zip_code = false;
            } else if (obj == 'state') {
                this.edit_state_index = index;
                this.edit_country = false;
                this.edit_state = true;
                this.edit_city = false;
                this.edit_township = false;
                this.edit_street = false;
                this.edit_zip_code = false;
            } else if (obj == 'city') {
                this.edit_city_index = index;
                this.edit_country = false;
                this.edit_state = false;
                this.edit_city = true;
                this.edit_township = false;
                this.edit_street = false;
                this.edit_zip_code = false;
            } else if (obj == 'township') {
                this.edit_township_index = index;
                this.edit_country = false;
                this.edit_state = false;
                this.edit_city = false;
                this.edit_township = true;
                this.edit_street = false;
                this.edit_zip_code = false;
            } else if (obj == 'street') {
                this.edit_street_index = index;
                this.edit_country = false;
                this.edit_state = false;
                this.edit_city = false;
                this.edit_township = false;
                this.edit_street = true;
                this.edit_zip_code = false;
            } else if (obj == 'zip_code') {
                this.edit_zip_code_index = index;
                this.edit_country = false;
                this.edit_state = false;
                this.edit_city = false;
                this.edit_township = false;
                this.edit_street = false;
                this.edit_zip_code = true;
            }
        }
    },
    resetUser(obj, index) {
        let userBasicInfo = JSON.parse(localStorage.getItem('address_data'));
        if(obj == "full_address_add_update") {
            this.edit_full_address = false;
            this.edit_country = false;
            this.edit_state = false;
            this.edit_city = false;
            this.edit_township = false;
            this.edit_street = false;
            this.edit_zip_code = false;
            this.address[index].country = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].country
            this.address[index].state = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].state
            this.address[index].city = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].city
            this.address[index].township = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].township
            this.address[index].street = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].street
            this.address[index].zip_code = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].zip_code
        } else {
            if (obj == "country") {
                this.edit_country = false;
                this.address[index].country = userBasicInfo[index] == undefined || null ? '' :  userBasicInfo[index].country
            } else if (obj == 'state') {
                this.edit_state = false;
                this.address[index].state = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].state
            } else if (obj == 'city') {
                this.edit_city = false;
                this.address[index].city = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].city
            } else if (obj == 'township') {
                this.edit_township = false;
                this.address[index].township = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].township
            } else if (obj == 'street') {
                this.edit_street = false;
                this.address[index].street = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].street
            } else if (obj == 'zip_code') {
                this.edit_zip_code = false;
                this.address[index].zip_code = userBasicInfo[index] == undefined || null ? '' : userBasicInfo[index].zip_code
            }
        }
    },
    async addAddressMethod(type, index) {
        try {
            let params = {};
            this.country_check_index = index;
            if(this.userBasicInfo[index].id) {
                params.id = this.userBasicInfo[index].id;
                if(type == 'full_address_add_update') {
                    params.country = this.address[index].country
                    params.state = this.address[index].state
                    params.city = this.address[index].city
                    params.township = this.address[index].township
                    params.street = this.address[index].street
                    params.zip_code = this.address[index].zip_code
                    params.address_type = this.address[index].address_type
                } else {
                    if (type == "country") {
                        params.country = this.address[index].country
                    } else if (type == 'state') {
                        params.state = this.address[index].state
                    } else if (type == 'city') {
                        params.city = this.address[index].city
                    } else if (type == 'township') {
                        params.township = this.address[index].township
                    } else if (type == 'street') {
                        params.street = this.address[index].street
                    } else if (type == 'zip_code') {
                        params.zip_code = this.address[index].zip_code
                    }
                }
                if(this.address[index].country == '' || this.address[index].country == null || this.address[index].country == undefined) {
                    this.select_country = true;
                } else {
                    this.select_country = false;
                    let response = await this.updateAddress(params, this.loggedInUser.user_id);
                    if(response.status_id == 1) {
                        this.GetUserDetails(this.$route.params.id);
                    }
                }
            } else {
                params.country = this.address[index].country
                params.state = this.address[index].state
                params.city = this.address[index].city
                params.township = this.address[index].township
                params.street = this.address[index].street
                params.zip_code = this.address[index].zip_code
                params.address_type = this.address[index].address_type
                if(this.address[index].is_primary) {
                  params.is_primary = true
                } else {
                  params.is_primary = false
                }
                if(this.address[index].country == '' || this.address[index].country == null || this.address[index].country == undefined) {
                    this.select_country = true;
                } else {
                    this.select_country = false;
                    let response = await this.addNewAddress(params, this.loggedInUser.user_id);
                    if(response.status_id == 1) {
                        this.GetUserDetails(this.$route.params.id);
                    }
                }
            }
        }
        catch(err) {
          // console.log(err);
        }
    },
  },
  components: {
    HalfCircleSpinner,
    DeleteAddress,
  },
  mounted() {
    EventBus.$on("addressInformation", () => {
      this.updateContactAddress();
    });
    EventBus.$on("hideuser", () => {
      this.hideEdit();
    });
  },
  created() {
    if (this.$route.params.id) {
      this.GetUserDetails(this.$route.params.id);
    } else {
      this.GetUserDetails(this.loggedInUser.id);
    }
    const dict = {
        custom: {
            country:{
                required: () => "Country is Required",
            },
        }
    };
    this.$validator.localize("en", dict);
  },
  destroyed() {
    EventBus.$off("addressInformation");
    EventBus.$off("hideuser");
  },
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser;
    },
    account() {
      return this.$store.getters.account;
    },
  },
};
</script>
<style>
.socialMedia.dropdown-toggle::after {
  margin-left: 5px;
}

@-moz-document url-prefix() {
  .inputMedia {
    padding-right: 26px !important;
  }
}
.mediaDropdown.dropdown-menu {
  margin: 0rem 0rem 0 !important;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-firstblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
.contact-details-tab-view.el-tabs.el-tabs--top
  .el-tabs__content
  .el-tab-pane
  .tabs-content-secondblock {
  border-radius: 5px;
  box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.16);
  border: solid 1px #cdd2da;
  background-color: #ffffff;
  margin: 5px 10px 15px;
}
textarea.textarea-control {
  height: auto;
}

textarea.textarea-control {
  display: block;
  width: 100%;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #4e5764;
  background-color: #fff;
  background-image: none;
  border: 1px solid #cdd2da;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
}
.input-group.digi-input-group {
  border: 1px solid #cdd2da !important;
}
.input-group.digi-input-group > .form-control {
  position: relative !important;
  -webkit-box-flex: 1 !important;
  -webkit-flex: 1 1 auto !important;
  -ms-flex: 1 1 auto !important;
  flex: 1 1 auto !important;
  width: 1% !important;
  margin-bottom: 0 !important;
  height: 22px !important;
  padding: 6px 12px 6px 2px !important;
  color: #4e5764;
  text-decoration: underline;
  border-bottom: 1px solid transparent !important;
}
.input-group.digi-input-group .input-group-addon {
  padding-left: 0rem !important;
  padding-right: 0.2rem !important;
  border-bottom: 1px solid transparent !important;
  padding-top: 2px;
  cursor: pointer;
}
.qrcode-block-view-account {
  border-radius: 6px;
  width: 104px;
  height: 105px;
  position: relative;
  display: inline-block;
  display: block;
  border: 1px solid #005dae;
  background: #d6e2ef;
}
.qrcode-content-view-account {
  text-align: center;
  margin: 6px auto;
  background: #d6e2ef !important;
}
.qr-logo-view-account {
  position: absolute;
  margin-top: 40px;
  margin-left: 35px;
  width: 30px;
}
.removeBlocks {
  right: 20px;
  margin-right: 2px;
}
.removeBlocksPhone {
  right: 18px;
  margin-right: 2px;
}
.removeBlocksPhone.removedAddPhone {
  right: 0px;
  margin-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactAddressView.vue